// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2872":"d32363d6","3897":"aa550165","4577":"aa550165","4909":"aa550165","8308":"aa550165"}[chunkId] + ".chunk.css";
};